import utils from '@src/common/utils'
import { Dic, Cache } from "$utils";
const stepOption = function(data) {
  return {
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    // calcHeight: 100,
    menuWidth: 200,
    labelWidth: '100',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '955px',
    emptyText: '暂无数据',
    column:data
  }
}
export default stepOption